import React from 'react';
import NewUser from './NewUser';
import Footer from '../../components/Footer';

function Dashboard() {
  return (
    <div className="w-full h-full">
      <NewUser />
      {/* <Footer /> */}
    </div>
  );
}

export default Dashboard;
